import React from 'react';
import FileList, { DownloadLink, PreviousVersions } from '../shared/FileList';
import { formatDate } from '../../utils/dateFormat';

// The files on a QC record, read-only, with the superseded ones collapsed
// underneath. Two pages show the same panel — the QC record in Management and
// the record a QC Addendum was raised against — so they show it from here
// rather than each keeping its own copy.
//
//   files  the record's files (superseded ones included — this splits them)
//   hrefOf (f) => download url
const label = (f) => (f.docType === 'QC_FORM' ? 'Signed form (uploaded)' : 'Supporting');

// Which version replaced it and when. `manual` means someone in Management
// uploaded the replacement, so there is no request number to point at.
const replacedBy = (f) => [
  f.supersededByRef ? `replaced by ${f.supersededByRef}` : 'replaced',
  f.supersededAt ? `on ${formatDate(f.supersededAt)}` : null,
].filter(Boolean).join(' ');

const QcRecordFiles = ({ files = [], hrefOf }) => {
  const current = files.filter((f) => !f.superseded);
  const previous = files.filter((f) => f.superseded);

  if (current.length === 0 && previous.length === 0) {
    return <p className="text-sm text-slate-500">No files attached.</p>;
  }
  return (
    <>
      <FileList
        files={current}
        row={(f) => ({
          name: f.originalName,
          stacked: true,
          badges: [[label(f), 'bg-slate-100 text-slate-600']],
          actions: <DownloadLink href={hrefOf(f)} label={null} newTab />,
        })}
      />
      <PreviousVersions count={previous.length}>
        <FileList
          files={previous}
          className="mt-1"
          row={(f) => ({
            name: f.originalName,
            stacked: true,
            muted: true,
            meta: [label(f), replacedBy(f)],
            actions: <DownloadLink href={hrefOf(f)} label={null} newTab />,
          })}
        />
      </PreviousVersions>
    </>
  );
};

export default QcRecordFiles;
